module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_7005.20b10e0c.png";